export default "__VITE_ASSET__BwR6OK3l__"